<template>
  <div>
    <vuestic-modal :show.sync="modal.show" ref="smallModal" v-bind:small="false" :cancelClass="'none'" okText="Fechar"
      cancelText="Fechar">
      <div slot="title">Informações</div>
      <div v-show="modal.load">
        <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
          <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
            <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
          </div>
        </div>
      </div>
      <div v-show="!modal.load">
        <vuestic-tabs :names="['Dados Básicos', 'Endereço']" ref="tabs">
          <div slot="Dados Básicos">
            <div class="row">
              <div class="col-md-3" style="text-align:center;">
                <img width="100" :src="'data:image/jpg;base64, ' + modal.conteudo.photoApp" alt="Foto">
              </div>
              <div class="col-md-3">
                <strong class="font-weight-bold">CPF:</strong><br>
                <span class="circle badge-success" v-if="modal.conteudo.flg_ativo"></span>
                <span class="circle badge-danger" v-if="!modal.conteudo.flg_ativo"></span>
                {{ modal.conteudo.cpf }}
              </div>
              <div class="col-md-3">
                <strong class="font-weight-bold">Nome:</strong><br>
                {{ modal.conteudo.nome }}
              </div>
              <div class="col-md-3">
                <!--
								<strong class="font-weight-bold">E-mail:</strong><br>
								{{ modal.conteudo.email }}
								-->
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-md-4">
                <!--
								<strong class="font-weight-bold">CNH:</strong><br>
								{{ modal.conteudo.cnh }}
								-->
              </div>
              <div class="col-md-4">
                <!--
								<strong class="font-weight-bold">Telefone/Celular:</strong><br>
								{{ modal.conteudo.telefone }}
								-->
              </div>
              <div class="col-md-4">
                <!--
								<strong class="font-weight-bold">Data de nascimento:</strong><br>
								{{ utils.formatDate(modal.conteudo.data_nascimento, true) }}
								-->
              </div>
            </div>
          </div>
          <div slot="Endereço">
            <div v-if="modal.conteudo.endereco_instrutor">
              <div class="row">
                <div class="col-md-4">
                  <strong class="font-weight-bold">UF:</strong><br>
                  {{ modal.conteudo.endereco_instrutor.endereco.uf }}
                </div>
                <div class="col-md-4">
                  <strong class="font-weight-bold">Cidade:</strong><br>
                  {{ modal.conteudo.endereco_instrutor.endereco.cidade }}
                </div>
                <div class="col-md-4">
                  <strong class="font-weight-bold">Bairro:</strong><br>
                  {{ modal.conteudo.endereco_instrutor.endereco.bairro }}
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-md-4">
                  <strong class="font-weight-bold">Logradouro:</strong><br>
                  {{ modal.conteudo.endereco_instrutor.endereco.logradouro }}
                </div>
                <div class="col-md-4">
                  <strong class="font-weight-bold">Número:</strong><br>
                  {{ modal.conteudo.endereco_instrutor.numero }}
                </div>
                <div class="col-md-4">
                  <strong class="font-weight-bold">CEP:</strong><br>
                  {{ modal.conteudo.endereco_instrutor.endereco.cep }}
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-md-12">
                  <strong class="font-weight-bold">Complemento:</strong><br>
                  {{ modal.conteudo.endereco_instrutor.complemento }}
                </div>
              </div>
            </div>
          </div>
        </vuestic-tabs>
      </div>
    </vuestic-modal>
  </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import InstrutoresController from './InstrutoresController';

export default {
  name: 'ModalInfo',
  components: {
    ...spinners,
  },
  data() {
    return {
      modal: {
        show: false,
        load: false,
        conteudo: {}
      },
    }
  },
  methods: {
    async open(idInstrutor) {
      this.detalhes(idInstrutor)
    },
    detalhes(idInstrutor) {
      let self = this

      this.$refs.smallModal.open()
      this.modal.load = true
      this.modal.conteudo = {}

      InstrutoresController.getInstrutorById(idInstrutor, function (response) {
        self.modal.conteudo = response.body.dados
        self.modal.load = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.box-container {
  background: #FFF;
  border-radius: 8px;

  &.small {
    padding: 1rem;
  }

  &.medium {
    padding: 2rem;
  }
}
</style>